import PropTypes from "prop-types";
import { useState } from "react";

// Components
import FrequencySelector from "@/PayPlans/components/Commons/FrequencySelector";
import OperatingCostsMake from "@/PayPlans/components/OperatingCostsMake";

// MUI
import { Grid, Stack } from "@mui/material";

export default function RenderContent(props) {
	const {
		tabIndex = 0,
		sectionId,
		readOnly,
		value,
		handleUpdateSwitches = () => {},
		handleUpdateTiers = () => {},
		handleValidation = () => {},
	} = props;
	const [disableAddColumn, setDisableAddColumn] = useState(false);

	const handleDisableFrequency = (disabledFrequencies) => {
		setDisableAddColumn(disabledFrequencies?.length === 2);
	};

	return (
		<Grid container>
			<Grid item xs={12} className={"models-tiered-area"}>
				<Stack direction={"row"} spacing={1.5}>
					<Stack direction={"row"} alignContent={"center"} alignItems={"center"} sx={{ minWidth: "200px" }}>
						<FrequencySelector
							make={value?.make}
							section={"OperatingCosts"}
							sx={{ width: "200px" }}
							disabled={readOnly}
							readOnly={readOnly}
							selected={value?.frequency}
							onChange={(item) => handleUpdateSwitches(sectionId, "frequency", item.value, tabIndex)}
							onDisabledFrequency={handleDisableFrequency}
						/>
					</Stack>
				</Stack>
				<OperatingCostsMake
					{...value}
					readOnly={readOnly}
					disableAddColumn={disableAddColumn}
					onActionUpdate={(make, tiers) => handleUpdateTiers(sectionId, make, tiers)}
					onActionValidation={(make, isValid) => handleValidation(sectionId, make, isValid)}
				/>
			</Grid>
		</Grid>
	);
}
RenderContent.propTypes = {
	tabIndex: PropTypes.number,
	sectionId: PropTypes.string,
	readOnly: PropTypes.bool,
	value: PropTypes.object,
	handleUpdateSwitches: PropTypes.func,
	handleUpdateTiers: PropTypes.func,
	handleValidation: PropTypes.func,
};
